var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioMike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15286_108222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.625,
    y: 12.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15286_108222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6251 26.1168C22.8696 26.1168 22.2335 25.8477 21.7168 25.3097C21.2002 24.7717 20.9418 24.1185 20.9418 23.35V17.1667C20.9418 16.4259 21.2026 15.7962 21.7241 15.2777C22.2457 14.7592 22.8791 14.5 23.6241 14.5C24.3692 14.5 25.0029 14.7592 25.5251 15.2777C26.0472 15.7962 26.3083 16.4259 26.3083 17.1667V23.35C26.3083 24.1185 26.05 24.7717 25.5333 25.3097C25.0167 25.8477 24.3806 26.1168 23.6251 26.1168ZM22.7918 32.6667V30.2083C21.214 30.0139 19.8515 29.3668 18.7043 28.2668C17.557 27.1668 16.8833 25.8139 16.6833 24.2082C16.65 23.9711 16.7117 23.7687 16.8683 23.6012C17.0248 23.4337 17.222 23.35 17.4598 23.35C17.6978 23.35 17.896 23.4319 18.0543 23.5957C18.2127 23.7597 18.314 23.9612 18.3583 24.2C18.5695 25.4888 19.1777 26.5444 20.1828 27.3668C21.1878 28.1889 22.3332 28.6 23.6191 28.6C24.9231 28.6 26.0751 28.1875 27.0751 27.3625C28.0751 26.5375 28.6807 25.4833 28.8918 24.2C28.9362 23.9612 29.0385 23.7597 29.1988 23.5957C29.3592 23.4319 29.5577 23.35 29.7946 23.35C30.0316 23.35 30.2278 23.4337 30.3833 23.6012C30.539 23.7687 30.6002 23.9711 30.5668 24.2082C30.3668 25.7916 29.6973 27.1388 28.5583 28.25C27.4195 29.3612 26.0528 30.0139 24.4583 30.2083V32.6667C24.4583 32.9027 24.3782 33.1007 24.2181 33.2605C24.0577 33.4202 23.8591 33.5 23.6221 33.5C23.3852 33.5 23.1877 33.4202 23.0293 33.2605C22.871 33.1007 22.7918 32.9027 22.7918 32.6667ZM23.6251 24.45C23.9196 24.45 24.1627 24.3431 24.3543 24.1293C24.546 23.9153 24.6418 23.6555 24.6418 23.35V17.1667C24.6418 16.8834 24.5444 16.6459 24.3496 16.4542C24.1546 16.2626 23.9131 16.1667 23.6251 16.1667C23.3371 16.1667 23.0956 16.2626 22.9006 16.4542C22.7057 16.6459 22.6083 16.8834 22.6083 17.1667V23.35C22.6083 23.6555 22.7042 23.9153 22.8958 24.1293C23.0875 24.3431 23.3306 24.45 23.6251 24.45Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMike);
export default __webpack_public_path__ + "static/media/audio_mike.40a1ad4f3292924c06266ca1431c4c5d.svg";
export { ForwardRef as ReactComponent };